const initialState = {
  users: [],
  loading: false,
  error: null,
  actionLoading: false,
  selectedUser: null
};

const UsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_USERS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_USERS_SUCCESS':
      return { ...state, loading: false, users: action.payload, error: null };
    case 'FETCH_USERS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'FETCH_USER_BY_ID_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'FETCH_USER_BY_ID_SUCCESS':
      return { ...state, actionLoading: false, selectedUser: action.payload, error: null };
    case 'FETCH_USER_BY_ID_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'ADD_USER_REQUEST':
    case 'UPDATE_USER_REQUEST':
    case 'DELETE_USER_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'ADD_USER_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        users: [action.payload, ...state.users],
        error: null
      };

    case 'UPDATE_USER_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        users: state.users.map((u) => (u.id === action.payload.id ? action.payload : u)),
        selectedUser: action.payload,
        error: null
      };

    case 'DELETE_USER_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        users: state.users.filter((u) => u.id !== action.payload),
        error: null
      };

    case 'ADD_USER_FAILURE':
    case 'UPDATE_USER_FAILURE':
    case 'DELETE_USER_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'UPDATE_USER_ROLE_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'UPDATE_USER_ROLE_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        users: state.users.map((user) => (user.id === action.payload.id ? { ...user, role: action.payload.role } : user)),
        error: null
      };
    case 'UPDATE_USER_ROLE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };
    case 'RESET_USER_PASSWORD_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'RESET_USER_PASSWORD_SUCCESS':
      return { ...state, actionLoading: false, error: null };

    case 'RESET_USER_PASSWORD_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };
    default:
      return state;
  }
};

export default UsersReducer;
